import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_BOARDING_POINTS](state, data) {
    state.allBoardingPoints = data
  },
}
